// Language codes
export const LANG_FI = "fi";
export const LANG_ENG = "en";

// Site lang
const url = window.location.href;
export const siteLang = url.includes('/eng/') ? 'en' : url.includes('/swe/') ? 'en' : 'fi';

// Country states
export const STATE_DEFAULT = 'default';
export const STATE_ACTIVE = 'active';
export const STATE_INACTIVE = 'inactive';

// Risk classes
export const RISK_CLASS_A = 'A';
export const RISK_CLASS_B = 'B';
export const RISK_CLASS_C = 'C';
export const RISK_CLASS_D = 'D';
export const RISK_CLASS_E = 'E';
export const RISK_CLASS_NONE = '-';

export const RISK_CLASS_A_COLOR = '#00a808';
export const RISK_CLASS_B_COLOR = '#0e6fed';
export const RISK_CLASS_C_COLOR = '#ffd401';
export const RISK_CLASS_D_COLOR = '#fb9100';
export const RISK_CLASS_E_COLOR = '#e6193f'
export const RISK_CLASS_NONE_COLOR = 'grey';

// Dropdown menu
export const MENU_TYPE_COUNTRY_DROPDOWN = 'country_dropdown';
export const MENU_TYPE_CONTINENT_DROPDOWN = 'continent_dropdown';
export const MENU_TYPE_RISK_CLASS_DROPDOWN = 'risk_class_dropdown';
export const MENU_TYPE_POLICY_DROPDOWN = 'policy_dropdown';